import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from './app.service';
import { DialogShowFullImageComponent } from './dialog-show-full-image.component';

import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';

import * as moment from 'moment';
import { Subscription } from 'rxjs';




@Component({
  selector: 'app-showgear',
  templateUrl: './showgear.component.html',
  styleUrls: ['./showgear.component.css'],
  providers: [{provide: MAT_DATE_LOCALE, useValue: 'da-DK'},
  
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
      },
      {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS}],
    encapsulation: ViewEncapsulation.None
})
export class ShowgearComponent implements OnInit, OnDestroy {

  constructor(public dialog: MatDialog, private serv: AppService, private route: ActivatedRoute,private _adapter: DateAdapter<any>,
    private router: Router) { }


  loaded = false

  id: number = 0
  gear = {}
  isOwner: boolean = false

  selfReservation: boolean = false

  reservations = []

  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl()
  })

  what = new FormControl()


  rangeHasBeenSelected = false
  reservationComment = new FormControl()
  reservationFail = false
  reservationFailReason = ""

  reservationSuccess = false

  handleRequestFail = false
  handleRequestFailReason = ""

  selectedDate= moment()
  selectedReservation = {}
  selectedReservationBorrower = {}
  hasReservation: boolean = false

  getReservationFail = false
  getReservationFailReason = ""
  
  categoriesObj = {}



  authSub: Subscription

  @ViewChild('calendar') _calendar;
  //@ViewChild('rangePicker') _rangePicker;


  selectedChange(event: any) {
    this.selectedDate = event

    /*
    for (let r of this.reservations) {
      if (event.isSameOrAfter(moment(r['start_date'])) && event.isSameOrBefore(moment(r['end_date'])) ) {
        this.selectedReservation = r

        return
      }
    }
    this.selectedReservation = {}
    */
    if (!this.isOwner) {
      return
    }


    this.serv.getReservation(this.id, event.year(), event.month()+1, event.date()).subscribe(ret => {
      if (ret['result']) {
        if ('reservation' in ret) {
          this.hasReservation = true
          this.selectedReservation = ret['reservation']
          this.selectedReservationBorrower = ret['borrower']
  
  
        } else {
          this.hasReservation = false
        }
        this.getReservationFail = false
        this.getReservationFailReason = ""
      } else {
        this.hasReservation = false
        this.getReservationFail = true
        this.getReservationFailReason = ret['reason']
      }
    })

  }

  dateClass: MatCalendarCellClassFunction<moment.Moment> = (cellDate, view) => {
  //dateClass  (cellDate, view) {
    //console.log(cellDate)
    //console.log(this.reservations)
    for (let r of this.reservations) {
      if (cellDate.isSameOrAfter(moment(r['start_date'])) && cellDate.isSameOrBefore(moment(r['end_date']))) {
        if (r['status'] == "udlaant" || r['status'] == "bruges") {
          return 'date-udlaant'
        } else if (r['status'] == "reserveret") {
          return 'date-reserveret'
        }
      }
    }
    return 'date-ledig'
  }

  dateFilter = (d: moment.Moment): boolean => {
    if (this.selfReservation) {
      if (d.isBefore(moment().startOf('day'))) {
        return false
      }
    } else {
      if (d.isBefore(moment().startOf('day').add(+this.gear['minimums_frist'], 'days'))) {
        return false
      }
    }
    for (let r of this.reservations) {
      if (d.isSameOrAfter(moment(r['start_date'])) && d.isSameOrBefore(moment(r['end_date']))) {
        if (r['status'] == "udlaant" || r['status'] == "bruges" || r['status'] == "reserveret") {
          return false
        }
      }
    } 
    return true
  }


  ngOnInit(): void {
    /*this.authSub = this.serv.isLoggedIn$.subscribe(x => {
      if (!x) {
        console.log("!x showgear")
        this.serv.willGoBack = true
        this.serv.savedRoute = this.router.url
        console.log(this.router.url)
        this.router.navigate(['/login'])
      } 
    })*/
    if (!this.serv._isLoggedIn) {

      this.serv.willGoBack = true
      this.serv.savedRoute = this.router.url

      console.log(this.router.url)
      this.router.navigate(['/login'])
    }
    this.route.params.subscribe(params => {

      this.id = +params['id']

      this.serv.getGear(this.id).subscribe(ret => {
        if (!ret) {
          return
        }
        this.gear = ret['gear']
        this.isOwner = ret['isOwner']

        for (let cat of ret['categories']) {
          this.categoriesObj[cat['id']] = cat
        }

        this.reservations = ret['reservations']
        //console.log(ret['reservations'])

        this.loaded = true
        //if (this.isOwner)
          //this._rangePicker.open()

        this.selectedChange(moment())
      })
    })
  }

  ngOnDestroy() {
    //this.authSub.unsubscribe()
  }

  ngOnInitWithoutDateChange() {
    this.serv.getGear(this.id).subscribe(ret => {
      this.gear = ret['gear']
      this.isOwner = ret['isOwner']

      this.reservations = ret['reservations']
      //console.log(ret['reservations'])


      
      this._calendar.updateTodaysDate()
      this.selectedChange(this.selectedDate)
    })
  }


  showFullImage(filename: string) {
    const dialogRef = this.dialog.open(DialogShowFullImageComponent, {maxWidth: '90%', maxHeight: '90vh', data: {filename: filename}})
  }

  onDateSelect() {
    if (this.range.get('start').value && this.range.get('end').value) {
      this.rangeHasBeenSelected = true
      this.reservationSuccess = false
      this.reservationFail = false
    } else {
      this.rangeHasBeenSelected = false
    }
  }

  requestReservation() {
    let start = this.range.get('start').value
    let end = this.range.get('end').value

    this.serv.requestReservation(this.id, start.year(), start.month()+1, start.date(), 
                        end.year(), end.month()+1, end.date(), (this.selfReservation ? "" : this.reservationComment.value)).subscribe(ret => {
      if (ret['result']) {
        this.reservationSuccess = true
        this.reservationFail = false
        this.ngOnInit()
      } else {
        this.reservationFail = true
        this.reservationSuccess = false

        this.reservationFailReason = ret['reason']
      }                    
      })
  }

  acceptRequest(id: number) {
    if (confirm("Er du sikker på at du vil acceptere denne anmodning?")) {
      this.serv.acceptRequest(id).subscribe( ret => {
        if (ret['result']) {
          this.handleRequestFail = false
          this.ngOnInitWithoutDateChange()
        } else {
          this.handleRequestFail = true
          this.handleRequestFailReason = ret['reason']
        }
      })
    }
    
  }

  denyRequest(id: number) {
    if (confirm("Er du sikker på at du vil afvise denne anmodning?")) {
      this.serv.denyRequest(id).subscribe( ret => {
        if (ret['result']) {
          this.handleRequestFail = false
          this.ngOnInitWithoutDateChange()
        } else {
          this.handleRequestFail = true
          this.handleRequestFailReason = ret['reason']
        }
      })
    }
    }
   unsetRequest(id: number) {
    if (confirm("Er du sikker på at du vil frigive denne reservation?")) {
      this.serv.unsetReservation(id).subscribe( ret => {
        if (ret['result']) {
          this.handleRequestFail = false
          this.ngOnInitWithoutDateChange()
        } else {
          this.handleRequestFail = true
          this.handleRequestFailReason = ret['reason']
        }
      })
    }
   }

}
